export default "__VITE_ASSET__DswLXyhi__"